module.exports = __webpack_public_path__ + "static/media/6.40d4ef82.png";